import { render, staticRenderFns } from "./index.vue?vue&type=template&id=deedb94e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=deedb94e&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=deedb94e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deedb94e",
  null
  
)

export default component.exports